module.exports = __webpack_public_path__ + "static/media/ARI-STEVI Smart 425-426.4890792d.jpg";